import { useSelector, useDispatch } from "react-redux";
import { setConfiguracion, resetConfiguracion, selectConfiguracion } from "../store/configuracion/configuracionSlice";

/**
 * Hook para el store de configuraciones
 * Mantiene la misma API que el store de Zustand
 */
export const useConfiguracionStore = () => {
  const dispatch = useDispatch();
  const configuracion = useSelector(selectConfiguracion);

  return {
    configuracion,
    setConfiguracion: config => dispatch(setConfiguracion(config)),
    resetConfiguracion: () => dispatch(resetConfiguracion()),
  };
};

// ===== Hooks específicos =====
export const useConfiguracion = () => useSelector(selectConfiguracion);

export const useConfiguracionActions = () => {
  const dispatch = useDispatch();

  return {
    setConfiguracion: config => dispatch(setConfiguracion(config)),
    resetConfiguracion: () => dispatch(resetConfiguracion()),
  };
};

export default useConfiguracionStore;
